

import React, { useRef, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import { Checkbox } from 'primereact/checkbox';
import { ColorPicker } from 'primereact/colorpicker';

import axios from '../axios';
import { useFormik } from 'formik';
import AppContext from '../Context/AppContext';
import Modal from '../Widgets/Modal';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { useMountEffect } from 'primereact/hooks';
import { InputNumber } from 'primereact/inputnumber';

const UserEditModal = ({ hide, data, update }) => {
    const existingNames = useRef([])
    const { sendMessage, toast, setBlocked } = useContext(AppContext)

    const [visible, setVisible] = useState(true)

    const formik = useFormik({
        initialValues: {
            id: data.id,
            user: data.user,
            change_password: false,
            password: '',
            permissions: data.permissions ? true : false
        },
        validate: (data) => {
            // Hey this is doing this
            let errors = {};
            if (!data.user) {
                errors.user = 'User is required';
            }
            else if (data.user.length < 2) {
                errors.user = 'User must have at least 2 letters'
            }
            else if (data.user.length > 15) {
                errors.user = 'User must be not longer than 15 letters'
            }
            else if (existingNames.current.some(item => item.toLowerCase() === data.user.toLowerCase())) {
                errors.user = 'User already exists in the database'
            }

            return errors;
        },
        onSubmit: async (data) => {
            setBlocked(true)
            if (formik.initialValues.user !== data.user) {
                try {
                    const response = await axios.get('/users/check', { params: { user: data.user } });
                    if (response.data.success) {
                        existingNames.current = [...existingNames.current, ...response.data.data]
                        formik.validateForm()
                        setBlocked(false)
                        return
                    }
                }
                catch (error) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to connect!', life: 3000 });
                    setBlocked(false)
                    return
                }
            }

            const new_data = {id: data.id, user: data.user, permissions: data.permissions}
            if(data.change_password) {
                new_data.password = data.password
            }

            try {
                const response = await axios.post('/users/edit', new_data);
                if (response.data.success) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: `User ${data.user} edited!`, life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to edit user!', life: 3000 });
                }
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to edit user!', life: 3000 });
            }

            setBlocked(false)
            update()
            sendMessage(JSON.stringify({ type: "users_edited" }))
            setVisible(false)
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={() => { setVisible(false) }} />
            <Button label="Save" icon="pi pi-check" className="m-0" type='submit' form='edit-user' />
        </React.Fragment>
    );

    return (
        <Modal header="Edit User" visible={visible} onHide={() => setVisible(false)} transitionOptions={{ onExited: () => hide() }} footer={footer}>
            <form onSubmit={formik.handleSubmit} id='edit-user' className='formgrid grid'>
                <div className="field col-12">
                    <label htmlFor="user">User</label>
                    <InputText name='user' id='user' value={formik.values.user} onChange={formik.handleChange} className={classNames('w-full', { 'p-invalid': isFormFieldValid('user') })} autoFocus />
                    {getFormErrorMessage('user')}
                </div>

                <div className="field col-12">
                    <div className="flex align-items-center">
                        <Checkbox name="change_password" inputId="change_password" checked={formik.values.change_password} onChange={formik.handleChange} />
                        <label htmlFor="change_password" className="ml-2">Change Password</label>
                    </div>
                </div>

                {formik.values.change_password && <div className="field col-12">
                    <label htmlFor="password">Password</label>
                    <Password name='password' inputId='password' value={formik.values.password} onChange={formik.handleChange} toggleMask className={classNames('w-full', { 'p-invalid': isFormFieldValid('password') })} inputClassName='w-full' feedback={false} />
                    {getFormErrorMessage('password')}
                </div>}

                <div className="field col-12 mb-1">
                    <label>Permissions</label>
                </div>
                <div className="field col-12">
                    <div className="flex align-items-center">
                        <Checkbox name="permissions" inputId="permissions" checked={formik.values.permissions} onChange={formik.handleChange} />
                        <label htmlFor="permissions" className="ml-2">Admin</label>
                    </div>
                </div>
            </form>
        </Modal>
    );
}

export default UserEditModal;